<template>
	<div id="intention">
		<Header2022 :navbg='true'></Header2022>
		<div class="follow">
			<div class="title">提交区域选择，我们将为您<i>建设满意的Smart0住宅！</i></div>
			<div class="follow-wrap">
				<div class="information">
					<div class="desc">Smart0采用全国创新的落地方式，你的家建在哪里由您决定！</div>
					<div class="smart0-flow">
						<img src="https://xcx-1257793586.cos.ap-beijing.myqcloud.com/fang/smart0/smart0-flow.png"
							alt="">
					</div>
					<div class="desc">提交表单后第一时间，我们将会安排品牌顾问联系您，为您提供专属服务，解答您对Smart0的一切疑问。</div>
					<div class="info-item">
						<div class="label">地区选择<i>⁎</i></div>
						<el-cascader v-model="value" :options="regionList" @change="handleChange" :props="props"
							clearable filterable></el-cascader>
					</div>
					<div class="info-item">
						<div class="label">联系姓名<i>⁎</i></div>
						<div class="value">
							<el-input v-model="name" placeholder="请输入真实姓名" maxlength="10"></el-input>
						</div>
					</div>
					<div class="info-item">
						<div class="label">联系方式<i>⁎</i></div>
						<div class="value">
							<el-input v-model="mobile" placeholder="请输入手机号" type="tel" maxlength="11"></el-input>
						</div>
					</div>
					<div class="info-item">
						<div class="label">电子邮箱</div>
						<div class="value">
							<el-input v-model="email" placeholder="请输入邮箱号" type="email"></el-input>
						</div>
					</div>
					<div class="prompt" v-if="intentionDetails">
						<div class="order-price-wrap">
							<div class="order-price-title">意向金</div>
							<div>{{intentionDetails.intention_price_format}}</div>
						</div>
						<div class="tips1">{{intentionDetails.intention_info_1}}</div>
						<div>{{intentionDetails.intention_info_2}}</div>
					</div>
					<div class="btn-wrap">
						<el-button class="btn" @click="submitTap">立即提交</el-button>
						<div class="select-wrap">
							<div class="select" @click="selectTap">
								<img src="https://xcx-1257793586.cos.ap-beijing.myqcloud.com/linli/images/duihao1.png"
									mode="widthFix" v-if="protocolChecked" />
								<img src="https://xcx-1257793586.cos.ap-beijing.myqcloud.com/linli/images/duihao2.png"
									mode="widthFix" v-else />
							</div>
							<div class="document">
								<i class="pact" @click="intentTap">提交订单即视为同意《意向订制协议》</i>
								<i class="pact" @click="privacyTap">《用户服务协议》及《隐私说明》</i>
							</div>
						</div>
						<el-link type="primary" @click="followTap">我的意向<i
								class="el-icon-view el-icon-arrow-right"></i></el-link>
					</div>
					<div v-if="intentionDetails">
						<div class="tips">{{intentionDetails.intention_info_3}}</div>
						<div class="tips">{{intentionDetails.intention_info_4}}</div>
					</div>
				</div>
				<div class="house-wrap">
					<div class="house-list" v-if="houseList && houseList.length>0">
						<div class="house-item" v-for="(item,index) in houseList" :key="index">
							<div class="image">
								<img :src="item.image" alt="">
							</div>
							<div class="reserve">
								<i>{{item.name}}</i>
								<el-button class="blackbtn" @click="reserveTap(item.product_id)">立即预定</el-button>
							</div>
						</div>
					</div>
					<div class="house-img" v-else>
						<img src="../../../assets/images/smart0/follow-house.png" alt="">
					</div>
				</div>
				<el-dialog :title="`意向提交成功，请尽快付款！订单号：${order_id}`" :visible.sync="dialogVisible" width="50%"
					:before-close="handleClose">
					<div class="code">
						<div class="refresh" @click="refreshTap">
							<i>请尽快扫码支付，如遇问题可</i>
							<i class="blue">刷新</i>
							<i>页面重新获取</i>
						</div>
						<div id="qrcodes" v-if="qrCodeText">
							<qrcodes :url="qrCodeText"
								iconurl="https://xcx-1257793586.cos.ap-beijing.myqcloud.com/linli/images/logo1.png" :wid="300"
								:hei="300" :imgwid="40" :imghei="40" @change="onDataUrlChange" />
						</div>
						<div class="tips">请使用微信扫一扫</div>
						<div class="tips">扫描二维码支付</div>
					</div>
				</el-dialog>
			</div>
		</div>
		<Footer2022></Footer2022>
	</div>
</template>

<script>
	history.pushState(null, null, document.URL);
	window.addEventListener('popstate', function() {
		history.pushState(null, null, document.URL);
	});
	import {
		mapState
	} from 'vuex'
	import {
		wxPayment
	} from '@/common/app.js';
	import utils from '@/common/utils.js';
	import qrcodes from "vue_qrcodes"
	import Header2022 from '@/components/header2022.vue'
	import Footer2022 from '@/components/footer2022.vue'
	export default {
		components: {
			Header2022,
			Footer2022,
			qrcodes
		},
		data() {
			return {
				name: '',
				mobile: '',
				email: '',
				houseList: [],
				value: [],
				regionList: [],
				props: {
					value: "id",
					label: "name",
					children: "items",
				},
				protocolChecked: false,
				intentionpdf: '',
				privacypdf: '',
				dialogVisible: false,
				appCount: null,
				qrCodeText: '',
				order_id: null,
				intentionDetails:null,
			}
		},
		computed: {
			...mapState(['ocApi', 'user_info', 'houseApi']),
		},
		created() {
			this.getRegionList();
			this.getAgreement('live_user_service_privacy');
			this.getAgreement('house_Intention_agreement');
			this.getIntentionTips();
		},
		beforeRouteLeave(to, from, next) {
			clearInterval(this.appCount);
			this.appCount = null;
			this.dialogVisible = false;
			next();
		},
		activated() {
			this.value = [];
			this.houseList = [];
			if (this.user_info) {
				this.mobile = this.user_info.telephone;
				this.name = this.user_info.fullname;
			}
		},
		methods: {
			getAgreement: function(agreementName) {
				this.$axios.get(this.ocApi + `book/banner?name=${agreementName}`)
					.then(res => {
						if (res.data.data.status == 1) {
							 if(agreementName=='live_user_service_privacy'){
								 this.privacypdf= res.data.data.images[0].link;
							 }else{
								 this.intentionpdf= res.data.data.images[0].link;
							 }
						} else {
							this.$message.error(res.data.message);
						}
					})
			},
			selectTap() {
				this.protocolChecked = !this.protocolChecked;
			},
			privacyTap() {
				window.open(this.privacypdf);
			},
			intentTap() {
				window.open(this.intentionpdf);
			},
			reserveTap(id) {
				this.$router.push({
					name: 'houseConfig',
					params: {
						id,
						houseType: 'smart0'
					}
				});
			},
			followTap() {
				this.$router.push({
					name: 'appointment',
					query: {
						tagName: 'intention',
					}
				});
			},
			handleChange(value) {
				this.gethouseList(value.slice(-1));
			},
			getIntentionTips() {
				this.$axios.get(this.houseApi + 'house/intention',{
					type:'smart0'
				})
					.then(res => {
						this.intentionDetails = res.data.data;
					})
					.catch(error => {
						this.$message.error(error.response.data.message);
					});
			},
			gethouseList(area_id) {
				this.$axios.get(this.houseApi + 'house/area_house_product_list', {
						params: {
							type: 'smart0',
							area_id,
						}
					})
					.then(res => {
						this.houseList = res.data.data.slice(0, 4);
					})
					.catch(error => {
						this.$message.error(error.response.data.message);
					});
			},
			submitTap() {
				if (!this.protocolChecked) {
					this.$message({
						message: "请阅读并同意订制协议及隐私说明！",
						type: 'warning',
						offset: 100,
						center: true,
						duration: 5000
					});
					return false;
				}
				if (!this.name || !this.mobile || this.value.length < 1) {
					this.$message({
						message: "请将带*号的信息填写完整！",
						type: 'warning',
						offset: 100,
						center: true,
						duration: 5000
					});
					return false;
				}
				var customer_id;
				if (this.user_info && this.user_info.customer_id) {
					customer_id = this.user_info.customer_id
				}
				this.$axios.post(this.ocApi + 'intentionCollection/registration', {
						name: this.name,
						telephone: this.mobile,
						email: this.email,
						zone_id: this.value[0],
						city_id: this.value[1],
						county_id: this.value[2],
						customer_from: 'website_pc',
						customer_id,
						customer_telephone:this.user_info.telephone,
						code:'',
					})
					.then(res => {
						if (res.data.status == 1) {
							
							// this.$confirm(res.data.message, '提交成功', {
							// 	type: 'success',
							// 	center: true,
							// 	showConfirmButton: false,
							// 	showCancelButton: false,
							// }).then(() => {
							// 	console.log('confirm')
							// }).catch(() => {
							// 	this.$router.replace({
							// 		path: 'smart0',
							// 	});
							// });
							this.order_id = res.data.data.pay.order_id;
							this.onDataUrlChange(res.data.data.pay.paycode.payment_params.code_url);
							this.dialogVisible = true;
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(error => {
						this.$message.error(error.response.data.message);
					});
			},
			handleClose(done) {
				this.$confirm('确认关闭支付二维码？确认后本订单关闭并跳转预约订单！')
					.then(_ => {
						this.dialogVisible = false;
						this.$router.replace({
							name: 'appointment',
							query: {
								tagName: 'intention',
							}
						});
					})
					.catch(_ => {});
			},
			onDataUrlChange(dataUrl) {
				this.qrCodeText = dataUrl;
				this.queryPay();
			},
			queryPay() {
				this.$axios.post(this.houseApi + `pc/house/orders/pay/query/${this.order_id}`, {
						id: this.order_id
					})
					.then(res => {
						//1是成功  0未支付
						if (!res.data.status || res.data.status > 0) {
							clearInterval(this.appCount);
							this.appCount = null;
						}
						if (res.data.status == 1) {
							this.$message.success(res.data.message);
							this.$router.replace({
								name: 'appointment',
								query: {
									tagName: 'intention',
								}
							});
							return;
						}
						if (res.data.status == 0) {
							this.polling();
						}
					})
					.catch(error => {
						clearInterval(this.appCount);
						this.appCount = null;
					});
			},
			polling() {
				var that = this;
				that.appCount = setInterval(function() {
					that.queryPay();
				}, 9000);
			},
			refreshTap: utils.debounce(
				function() {
					this.continuePay();
				},
				500,
				true
			),
			continuePay() {
				this.$axios.post(this.houseApi + `pc/house/orders/${this.order_id}/pay`, {
						telephone: this.user_info.telephone,
						id: this.order_id
					})
					.then(res => {
						if (res.data.status == 1) {
							var code = res.data.data.paycode.payment_params.code_url;
							this.onDataUrlChange(code);
						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(error => {
						this.$message.error(error.message);
					});
			},
			getRegionList() {
				this.$axios.get(this.ocApi + 'regions/get_zone_and_city')
					.then(res => {
						if (res.data.countries[0].status == 1) {
							this.regionList = res.data.countries[0].items;
							// 处理区域为空数据
							for (let arr of this.regionList) {
								arr.items.forEach((item, index) => {
									if (item.items.length < 1) {
										Reflect.deleteProperty(item, 'items');
									}
								})
							}

						} else {
							this.$message.error(res.data.message);
						}
					})
					.catch(error => {
						this.$message.error(error.response.data.message);
					});
			}
		}
	}
</script>

<style lang="scss">
	#intention {
		.follow {
			padding: 150px 4% 0;
			box-sizing: border-box;
			width: 100%;

			.follow-wrap {
				display: flex;
				justify-content: space-between;
				.order {
					font-size: 20px;
					padding-left: 70px;
				}
				
				.code {
					display: flex;
					align-items: center;
					flex-direction: column;
					position: relative;
					margin-bottom: 30px;
				
					#qrcodes {
						margin-bottom: 40px;
					}
				
					.tips {
						width: 300px;
						color: #FFFFFF;
						background-color: #ff7674;
						font-size: 14px;
						line-height: 18px;
						font-weight: 700;
						padding: 10px 0;
						text-align: center;
					}
				}
				
				.refresh {
					margin-top: 20px;
					font-size: 20px;
					color: #999999;
					margin-bottom: 20px;
				
				
					.blue {
						margin-left: 4px;
						color: #03a3ff;
						cursor: pointer;
					}
				}
			}

			.house-img {
				margin-top: 40px;

				img {
					width: 100%;
					height: auto;
				}
			}

			.title {
				font-size: 36px;
				line-height: 38px;

				i {
					font-size: 38px;
					font-weight: 800;
				}
			}

			.information {
				margin-bottom: 30px;
				max-width: 32%;

				.smart0-flow {
					height: 34px;
					margin: 0px 0 45px;

					img {
						width: 100%;
					}
				}

				.desc {
					line-height: 20px;
					margin: 15px 0;
					font-weight: 800;
				}

				.el-input__inner {
					width: 480px;
					border-radius: 10px;
				}

				.info-item {
					margin-bottom: 30px;
					font-size: 22px;

					.label {
						font-size: 22px;
						line-height: 22px;
						margin-bottom: 13px;
					}

					.right {
						font-size: 18px;
					}

					i {
						color: #FF0000;
					}
				}
				.prompt {
					width: 76%;
					margin-top: 17px;
					font-size: 14px;
					font-weight: 300;
					padding: 15px 18px 23px 29px;
					line-height: 18px;
					border: 2px solid #00C9FF;
					border-radius: 10px;
					margin-bottom: 26px;
					.tips1{
						margin-bottom: 10px;
					}
					.order-price-wrap {
						margin-bottom: 10px;
						font-size: 14px;
						color: #464c65;
						font-weight: bold;
					}
				}
				
				.btn-wrap {
					width: 80%;
					text-align: center;

					.btn {
						border: 1px solid #000000;
						color: #000000;
						cursor: pointer;
						width: 258px;
						height: 42px;
						margin-bottom: 10px;
						border-radius: 20px;
					}
				}

				.el-link {
					margin-bottom: 10px;
				}

				.select-wrap {
					display: flex;
					align-items: center;
					margin: 0px 0 10px 0;
					font-size: 14px;
					justify-content: center;
				}

				.document {
					width: 80%;
					text-align: start;
					.pact {
						background: linear-gradient(0deg, #00C9FF 0%, #11ED84 100%);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
						cursor: pointer;
						
					}
				}

				.select {
					width: 20px;
					height: 20px;
					border-radius: 100%;
					overflow: hidden;
					margin-right: 10px;

					img {
						width: 100%;
					}
				}

				.tips {
					font-size: 12px;
					font-weight: 200;
					color: #595959;
					line-height: 20px;
					margin-bottom: 5px;
				}
			}

			@media only screen and (max-width:1440px) {
				.information {
					.el-input__inner {
						width: 360px;
						border-radius: 10px;
					}

					.info-item {
						margin-bottom: 25px;
						font-size: 20px;
					}
				}
			}

			@media only screen and (max-width:1280px) {
				.information {
					.el-input__inner {
						width: 320px;
						border-radius: 10px;
					}
				}
			}

			.house-wrap {
				padding-top:60px;
				max-width: 58%;
				flex: 1;

				.house-list {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-around;
					margin-top: 8%;

					.house-item {
						width: 35%;
						margin-bottom:2%;

						.image {
							position: relative;
							overflow: hidden;
							img {
								border-radius: 8px;
								width: 100%;
								height: 100%;
								object-fit: cover;
								display: block;
							}
						}

						.reserve {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-top: 20px;

							i {
								font-size: 24px;
							}

							.el-button {
								width: 28%;
								height: 46px;
								background: linear-gradient(90deg, #01CDF2 0%, #0FE993 100%);
								border-radius: 24px;
								font-size: 18px;
								color: #FFFFFF;
								display: flex;
								justify-content: center;
								align-items: center;
							}
						}

						@media only screen and (max-width:1680px) {
							.reserve {
								i {
									font-size: 22px;
								}

								.el-button {
									height: 42px;
									border-radius: 24px;
									font-size: 18px;
								}
							}

							.image {
								img {
									height: 21.5vh;
								}
							}
						}

						@media only screen and (max-width:1440px) {
							.reserve {
								i {
									font-size: 20px;
								}

								.el-button {
									height: 36px;
									border-radius: 24px;
									font-size: 14px;
								}
							}
						}

						@media only screen and (max-width:1280px) {
							.reserve {
								i {
									font-size: 16px;
								}

								.el-button {
									height: 34px;
									border-radius: 24px;
									font-size: 12px;
								}
							}
						}
					}
				}
			}
		}
		
	}
</style>